import ENUM_CONSTANTS from '@components-shared/enum.constants';
import { keyMap } from '@locales/lokalise/keyMap';
import { getCurrentMonthUtc } from '@utils/library/dateTime/dateTime';

export const TH_FILTER_FIELDS_MT4_AND_GMI = [
  {
    name: 'closeTime',
    title: keyMap.tradingAccountsTableHistoryCloseTimeTitle,
    type: 'dateTimeRange',
    defaultValue: getCurrentMonthUtc(),
    isServerTime: true,
  },
  {
    name: 'cmd',
    title: keyMap.tradingAccountsTableHistoryCmdTitle,
    type: 'select',
    options: ENUM_CONSTANTS.MT4_CMD,
  },
  {
    name: 'ticket',
    title: keyMap.tradingAccountsTableHistoryTicketTitle,
    type: 'number',
  },
  {
    name: 'symbol',
    title: keyMap.tradingAccountsTableHistorySymbolTitle,
  },
  {
    name: 'commission',
    title: keyMap.tradingAccountsTableHistoryCommissionTitle,
    type: 'numberRange',
  },
  {
    name: 'profit',
    title: keyMap.tradingAccountsTableHistoryProfitTitle,
    type: 'numberRange',
  },
];

export const TH_FILTER_FIELDS_MT5 = [
  {
    name: 'closeTime',
    title: keyMap.tradingAccountsTableHistoryCloseTimeTitle,
    type: 'dateTimeRange',
    isServerTime: true,
    defaultValue: getCurrentMonthUtc(),
  },
  {
    name: 'action',
    title: keyMap.tradingAccountsTableHistoryCmdTitle,
    type: 'select',
    options: ENUM_CONSTANTS.HISTORY_MT5_ACTION,
  },
  {
    name: 'ticket',
    title: keyMap.tradingAccountsTableHistoryTicketTitle,
    type: 'number',
  },
  {
    name: 'symbol',
    title: keyMap.tradingAccountsTableHistorySymbolTitle,
  },
  {
    name: 'commission',
    title: keyMap.tradingAccountsTableHistoryCommissionTitle,
    type: 'numberRange',
  },
  {
    name: 'profit',
    title: keyMap.tradingAccountsTableHistoryProfitTitle,
    type: 'numberRange',
  },
];

export const TH_FILTER_FIELDS = {
  Meta4: TH_FILTER_FIELDS_MT4_AND_GMI,
  Meta5: TH_FILTER_FIELDS_MT5,
  Gmi: TH_FILTER_FIELDS_MT4_AND_GMI,
};
